import React from 'react';

import { formatBytes } from '../utils/format';

const STATE_LABEL = {
    pending: 'wartet',
    uploading: 'lädt…',
    done: 'eingereicht',
    error: 'Fehler',
};

const STATE_TONE = {
    pending: '',
    uploading: ' file-row-active',
    done: ' file-row-done',
    error: ' file-row-error',
};

/**
 * Liste der ausgewaehlten Dateien mit editierbarem Namen und Upload-Zustand.
 *
 * @param {{id, file, name, state, error}[]} entries
 */
export default function FileQueue({ entries, onRename, onRemove, nameError, busy }) {
    if (!entries.length) return null;

    return (
        <ul className="file-queue">
            {entries.map((entry, index) => (
                <li key={entry.id} className={`file-row${STATE_TONE[entry.state] || ''}`}>
                    <div className="file-row-head">
                        <span className="file-row-index">{index + 1}</span>
                        <span className="file-row-name" title={entry.file.name}>
                            {entry.file.name}
                        </span>
                        <span className="file-row-size">{formatBytes(entry.file.size)}</span>
                        <span className="file-row-state">{STATE_LABEL[entry.state]}</span>
                        {!busy && entry.state !== 'done' && (
                            <button
                                type="button"
                                className="file-row-remove"
                                onClick={() => onRemove(entry.id)}
                                aria-label={`${entry.file.name} entfernen`}
                            >
                                ×
                            </button>
                        )}
                    </div>

                    <label className="file-row-rename">
                        <span className="sr-only">Name für {entry.file.name}</span>
                        <input
                            type="text"
                            value={entry.name}
                            onChange={(event) => onRename(entry.id, event.target.value)}
                            disabled={busy || entry.state === 'done'}
                            aria-invalid={Boolean(nameError(entry.name))}
                            placeholder="Dateiname für das Ergebnis"
                        />
                    </label>

                    {entry.error && <p className="field-error">{entry.error}</p>}
                    {nameError(entry.name) && <p className="field-error">{nameError(entry.name)}</p>}
                </li>
            ))}
        </ul>
    );
}
